import { getMetaContent } from "src/shared/inline_boot";

function injectScript({ src, async = true, attrs = {} }) {
  const script = document.createElement("script");
  script.src = src;
  script.async = async;
  Object.keys(attrs).forEach((key) => {
    script.setAttribute(key, attrs[key]);
  });
  document.head.appendChild(script);
}

document.addEventListener("DOMContentLoaded", function () {
  const csLang = getMetaContent("cs-lang");
  const cookieScriptId = getMetaContent("cookie-script-id");
  if (cookieScriptId) {
    const attrs = { charset: "UTF-8" };
    if (csLang) {
      attrs["data-cs-lang"] = csLang;
    }
    injectScript({
      src: `//cdn.cookie-script.com/s/${cookieScriptId}.js`,
      attrs: attrs
    });
  }

  const gtmId = getMetaContent("gtm-id");
  if (gtmId) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    const gtmScript = document.createElement("script");
    gtmScript.async = true;
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;
    document.head.appendChild(gtmScript);
  }

  const gaFindmylostId = getMetaContent("ga-findmylost-id");
  if (gaFindmylostId) {
    injectScript({
      src: `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaFindmylostId)}`
    });
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", gaFindmylostId);

    const gaTenantId = getMetaContent("ga-tenant-id");
    if (gaTenantId) {
      window.gtag("config", gaTenantId);
    }
  }

  window.googleMapsLoaded = false;
  window.initAutocompleteAndMap = function () {
    window.googleMapsLoaded = true;
    console.log("Google Maps API callback (stub) called.");
  };
});
